// extracted by mini-css-extract-plugin
export var numpadContainer = "_m6-1";
export var phoneButton = "_m6-0";